import { KoobButton, KoobModal, KoobTitle, sanitizeRichText } from '@koob/ui';
import { useTranslation } from 'react-i18next';

const CancellationPolicies = ({ policies, setShowContractingCondition }) => {
  const { t } = useTranslation('hotel');

  return (
    <KoobModal
      open={true}
      setOpen={() => setShowContractingCondition(false)}
      widthClass="sm:max-w-5xl"
    >
      <div className="max-h-[600px] overflow-y-auto">
        <div className="px-3">
          <KoobTitle>{t('contractingPolicies')}</KoobTitle>
        </div>
        <div className="mt-4">
          <div
            dangerouslySetInnerHTML={{
              __html: sanitizeRichText(policies.contractingConditions ?? ''),
            }}
          />
        </div>
      </div>

      <div className="mt-5 flex justify-end">
        <KoobButton onClick={() => setShowContractingCondition(false)}>
          {t('misc:close')}
        </KoobButton>
      </div>
    </KoobModal>
  );
};

export default CancellationPolicies;
